// extracted by mini-css-extract-plugin
export default {"SpokeAudioPlayer":"SpokeAudioPlayer__Z726n","SpokeAudioPlayerSpeed":"SpokeAudioPlayerSpeed__yTITS","SpokeAudioCurrentSpeed":"SpokeAudioCurrentSpeed__yhTCk"};